// extracted by mini-css-extract-plugin
export default {"socialMedias":"socialMedias_socialMedias__105it"};